import ApiService from '@/services/api.service'


const InventoryItemService = {
    getAll( parameter) {          
      const requestData = {
        method: 'get',
        url: "/DrugInventoryItems/",
        headers: {
        },
        params: { 
          SearchCriteria: parameter.SearchCriteria,
          PageSize: parameter.PageSize,          
          PageNumber : parameter.PageNumber        
        }
      }     
      return ApiService.customRequest(requestData);         
    },  
  
    get(id) {
      return ApiService.get(`/DrugInventoryItems/${id}`);
    },

    add(data){
      return ApiService.post(`/DrugInventoryItems`,data)
    },

    delete(id){
      return ApiService.delete(`/DrugInventoryItems/${id}`)
    },
    
    update(id,data){
      return ApiService.put(`/DrugInventoryItems/${id}`,data)
    },

    getDispensingInfo(code) {
      return ApiService.get(`/DrugInventoryItems/DispensingInfo/${code}`);
    },   
}
  
  export default InventoryItemService;